import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { numberTypesDataSource } from 'infrastructure/data-sources/number-types';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { INumberTypeItem } from 'infrastructure/data-sources/number-types';

type Options = IBaseSelectBoxOption<INumberTypeItem['id'], INumberTypeItem>[];

interface INumberTypeSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const NumberTypeSelectBox: React.FC<INumberTypeSelectBoxProps> = (props) => {
  const dataSource = useMemo(() => numberTypesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default NumberTypeSelectBox;
